import { Link } from 'react-router-dom';
import { Phone, Mail, MessageCircle } from 'lucide-react';

const Footer = () => (
  <footer className="relative z-10 bg-ocean-dark/80 backdrop-blur-xl border-t border-white/10" data-testid="app-footer">
    <div className="max-w-6xl mx-auto px-4 sm:px-6 py-10">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
        {/* Brand */}
        <div>
          <div className="flex items-center gap-2 mb-3">
            <img src="/logo.jpg" alt="Triple A" className="w-8 h-8 rounded-lg" />
            <div>
              <p className="font-serif text-sm font-bold text-white">Triple A</p>
              <p className="text-[8px] text-gold tracking-widest uppercase">Travel Solutions</p>
            </div>
          </div>
          <p className="text-white/50 text-xs leading-relaxed">Awake. Aware. Arise for better travel experiences. Your end-to-end travel partner.</p>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="text-white font-semibold text-sm mb-3">Quick Links</h4>
          <ul className="space-y-1.5">
            <li><Link to="/about" className="text-white/50 hover:text-gold text-xs transition-colors">About Us</Link></li>
            <li><Link to="/travel-services" className="text-white/50 hover:text-gold text-xs transition-colors">Travel Services</Link></li>
            <li><Link to="/tour-packages" className="text-white/50 hover:text-gold text-xs transition-colors">Tour Packages</Link></li>
            <li><Link to="/contact" className="text-white/50 hover:text-gold text-xs transition-colors">Contact</Link></li>
            <li><Link to="/faq" className="text-white/50 hover:text-gold text-xs transition-colors" data-testid="footer-faq">FAQ</Link></li>
          </ul>
        </div>

        {/* Legal */}
        <div>
          <h4 className="text-white font-semibold text-sm mb-3">Legal</h4>
          <ul className="space-y-1.5">
            <li><Link to="/terms" className="text-white/50 hover:text-gold text-xs transition-colors" data-testid="footer-terms">Terms & Conditions</Link></li>
            <li><Link to="/terms-of-use" className="text-white/50 hover:text-gold text-xs transition-colors" data-testid="footer-terms-of-use">Terms of Use</Link></li>
            <li><Link to="/privacy" className="text-white/50 hover:text-gold text-xs transition-colors" data-testid="footer-privacy">Privacy Policy</Link></li>
          </ul>
        </div>

        {/* Contact */}
        <div>
          <h4 className="text-white font-semibold text-sm mb-3">Get in Touch</h4>
          <ul className="space-y-2">
            <li>
              <a href="tel:+61401050457" className="flex items-center gap-2 text-white/50 hover:text-gold text-xs transition-colors">
                <Phone className="w-3.5 h-3.5" /> +61 401 050 457
              </a>
            </li>
            <li>
              <a href="tel:+61424024078" className="flex items-center gap-2 text-white/50 hover:text-gold text-xs transition-colors">
                <Phone className="w-3.5 h-3.5" /> +61 424 024 078
              </a>
            </li>
            <li>
              <a href="mailto:triplea@tripleabooking.com" className="flex items-center gap-2 text-white/50 hover:text-gold text-xs transition-colors">
                <Mail className="w-3.5 h-3.5" /> triplea@tripleabooking.com
              </a>
            </li>
            <li>
              <a href="https://api.whatsapp.com/send?phone=61401050457" target="_blank" rel="noopener noreferrer"
                className="flex items-center gap-2 text-white/50 hover:text-green-400 text-xs transition-colors">
                <MessageCircle className="w-3.5 h-3.5" /> WhatsApp
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="border-t border-white/10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-white/40 text-xs">&copy; {new Date().getFullYear()} Triple A Travel Solutions. All rights reserved.</p>
        <p className="text-white/30 text-[10px]">Powered by AI. Made with care in Australia.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
